"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TempColorizer = exports.SpeedColorizer = exports.LutColorizer = exports.SimpleColorizer = void 0;
const three_1 = require("three");
const Lut_1 = require("three/examples/jsm/math/Lut");
class SimpleColorizer {
    constructor(color = new three_1.Color("#29BEB0")) {
        this.color = color;
    }
    getColor() {
        return this.color;
    }
}
exports.SimpleColorizer = SimpleColorizer;
class LutColorizer {
    constructor(lut = new Lut_1.Lut("cooltowarm")) {
        this.lut = lut;
    }
}
exports.LutColorizer = LutColorizer;
class SpeedColorizer extends LutColorizer {
    constructor(minSpeed, maxSpeed) {
        super();
        this.lut.setMin(minSpeed);
        this.lut.setMax(maxSpeed);
    }
    getColor(meta) {
        return this.lut.getColor(meta.speed);
    }
}
exports.SpeedColorizer = SpeedColorizer;
class TempColorizer extends LutColorizer {
    constructor(minTemp, maxTemp) {
        super();
        this.lut.setMin(minTemp);
        this.lut.setMax(maxTemp);
    }
    getColor(meta) {
        return this.lut.getColor(meta.temp);
    }
}
exports.TempColorizer = TempColorizer;
